<template lang="pug">
.refugio-estadisticas
  GChart(
      type="PieChart"
      :data="chartData"
      :options="chartOptions"
    )
  .icon(v-if="icon")
    i.center-icon(:class="`ap-${icon}`")
</template>

<script>
import { GChart } from 'vue-google-charts'
import { clone } from '@/utils/object.js'
import theme from '@/theme.js'

export default {
  components: {
    GChart
  },
  props: {
    data: Array,
    icon: String,
    options: {}
  },
  data () {
    return {
      chartOptions: {
        pieSliceText: 'none',
        legend: {
          position: 'labeled',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'none'
        },
        colors: Object.values(theme.pie),
        chartArea: { left: '10', right: '10', top: '12', bottom: '30' },
        pieHole: 0.4
      }
    }
  },
  computed: {
    chartData () {
      return clone(this.data)
    }
  },
  mounted () {
    this.chartOptions = {
      ...this.chartOptions,
      ...this.options
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/refugios/statistic'
</style>
